import { PageShell } from '../../ui/PageShell';
import { SettingsGroupCard, SettingsNavItem } from '../settings/settings-shared';

export function OzonHomePage() {
  return (
    <PageShell title="Ozon">
      <SettingsGroupCard title="Разделы">
        <SettingsNavItem title="Товар" to="/ozon/products" />
        <SettingsNavItem title="Остатки" to="/ozon/stocks" />
        <SettingsNavItem title="Экономика магазина" to="/ozon/store-economics" />
        <SettingsNavItem title="Динамика продаж" to="/ozon/dynamic" isLast />
      </SettingsGroupCard>
    </PageShell>
  );
}
